import { useQuery } from "@tanstack/react-query"
import api from "api"

type Resource = ("languages" | "subjects" | "countries" | "curricula")[]

export const useResource = (resource: Resource) => {
  const languages = useQuery({
    refetchOnMount: false,
    enabled: resource.includes("languages"),
    queryKey: ["languages"],
    queryFn: () => api.global.languages.list({ params: { page: "-1" } }),
  })
  const subjects = useQuery({
    refetchOnMount: false,
    enabled: resource.includes("subjects"),
    queryKey: ["subjects"],
    queryFn: () => api.global.subjects.list({ params: { page: "-1" } }),
  })
  const countries = useQuery({
    refetchOnMount: false,
    enabled: resource.includes("countries"),
    queryKey: ["countries"],
    queryFn: () => api.global.countries.list({ params: { page: "-1" } }),
  })
  const curricula = useQuery({
    refetchOnMount: false,
    enabled: resource.includes("curricula"),
    queryKey: ["curricula"],
    queryFn: () => api.global.curricula.list({ params: { page: -1 } }),
  })

  return {
    languages: languages.data || [],
    subjects: subjects.data || [],
    countries: countries.data || [],
    curricula: curricula.data || [],
  }
}
